import React from 'react';

import { TimelineDate } from './TimelineDate';
import { TimelineDot } from './TimelineDot';
import { TimelineProgress } from './TimelineProgress';

interface TimelineItemProps {
  date: string;
  maxCompletion?: number;
  delta?: number;
  showLine?: boolean;
  timePeriod?: number;
  children?: React.ReactNode;
}

export function TimelineItem({
  date,
  maxCompletion,
  delta,
  showLine = true,
  timePeriod,
  children,
}: TimelineItemProps): JSX.Element {
  return (
    <div className="relative pb-8 last:pb-0">
      {showLine && (
        <div className="absolute left-2 top-1 w-px h-[calc(100%-0.25rem)] bg-gray-200 z-0" />
      )}
      <div className="flex items-center">
        <TimelineDot />
        <TimelineDate date={date} />
        <div className="flex-1" />
        {delta !== undefined && maxCompletion !== undefined ? (
          <TimelineProgress maxCompletion={maxCompletion} delta={delta} />
        ) : null}
        {timePeriod !== undefined ? (
          <TimelineProgress timePeriod={timePeriod} />
        ) : null}
      </div>
      {children}
    </div>
  );
}
